const config = {
  dev:false,
  class:'tyzl',
  title:process.env.VUE_APP_TITLE || '驿租末端综合数字化平台',
  // footer:process.env.VUE_APP_COPY || '中国电信' || '浙江天邮科技有限公司',
  footer:process.env.VUE_APP_COPY || '广东天邮供应链科技有限公司 ',
  icp:'粤ICP备2022112709号',
  rate:1,
  hideLogo:false
}


export default config